import styled from 'vue-styled-components'

export default styled.div`
& .mask-list{
    & tr {
        cursor: pointer;
    }
}
& .widget-content {
    flex-direction: column;
    margin: 0;
}
& .table-content {
    padding: 15px;
    background-color: #f7f7f7;
    border: 1px dashed #efefef;
    border-radius: 15px;
}
& .btn-add-new {
    z-index: 9;
}
 & .final-mask-content{
     & .control {
         width: 100%;
     }
 }
& .widget {
    background-color: #FFFFFF;
    border: 1px solid #efefef;
    padding: 15px;
    border-radius: 5px;
    & .w-title {
        font-size: 1.6em;
        text-align: center;
        padding-bottom: 1rem;
        border-bottom: 1px solid #efefef;
    }
    & .table-values {
        width: 100%;
        & .header {
            background-color: #2962ff;
            color: #FFFFFF;
            font-size: 1.2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0.5rem;
            border-radius: 5px 5px 0 0;
        }
        & .body {
            & .b-header {
                display: flex;
            }
                & .col {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0.5rem;
                    text-align: center;
                    max-width: 30%;
                    &.value, &.mask, &.input-content {
                        background-color: #efefef;
                    }
                    &.th {
                            border-bottom: 1px solid #efefef;
                            font-weight: bold;
                    }
                    &.subject {
                        max-width: 40%;
                    }
                    &.input-content {
                        & input {
                            height: 34px;
                        }
                    }
                    &.label {
                        font-weight: bold;
                        font-size: 1.1em;
                        text-align: left;
                        justify-content: flex-start;
                    }
                }
            & .item {
                display: flex;
                border-bottom: 1px solid #efefef;
                cursor: pointer;
                &.selected {
                    background-color: #167df0;
                    & .label {
                        color: #FFFFFF;
                    }
                    & .input-content {
                        background-color: #167df0;
                    }
                }
            }
        }
    }
    
    & .mask-content {
        padding: 15px;
        & .label {
            display: block;
            font-size: 1.2em;
            font-weight: bold;
        }
        & .final-mask {
            font-size: 1.3em;
            color: #555555;
        }
        & .mask-positions {
            & .position-controler {
                display: flex;
                & div {
                    display: flex;
                    &.shortable-chosen{
                        background-color: red;
                        & .option {
                            background-color: red !important;
                        }
                    }
                }
                & .option {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid #efefef;
                    box-shadow: 1px 2px 3px #cccccc;
                    cursor: pointer;
                    padding: 10px;
                    border-radius: 5px;
                    margin-right: 10px;
                    &.selected {
                        background-color: #167df0;
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
}
`;